import { insertMentionNode } from '#pplx/frontend/apps/ask/ask-input/ask-input-mentions/insertMentionNode.js';
import { getComposerSkillMention } from '#pplx/frontend/apps/ask/skills/getComposerSkillMention.js';
// TODO(#p-inbox-box): Keep Lexical behind a narrower input-box insertion boundary.
export function insertSkillMentionNode(editor, skill, intl, options = {}) {
    const mention = getComposerSkillMention({
        skill,
        intl,
        ...(options.prefixWithSlash === undefined ? {} : { prefixWithSlash: options.prefixWithSlash }),
    });
    insertMentionNode(editor, {
        variant: 'skills',
        text: mention.text,
        localizedName: mention.localizedName,
        ...(mention.prefixWithSlash === undefined
            ? {}
            : { prefixWithSlash: mention.prefixWithSlash }),
        uuid: mention.id,
        url: mention.url,
        icon: mention.icon,
    }, options);
}
//# sourceMappingURL=insertSkillMentionNode.js.map